var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.0432C11.2071 15 12.0789 15 13.2 15H22.8C23.9211 15 24.7929 15 25.5 15.0432M10.5 15.0432C9.61752 15.0971 8.99144 15.2182 8.45704 15.4905C7.61031 15.9219 6.9219 16.6103 6.49047 17.457C6 18.4196 6 19.6798 6 22.2V24.3C6 26.8202 6 28.0804 6.49047 29.043C6.9219 29.8897 7.61031 30.5781 8.45704 31.0095C9.41965 31.5 10.6798 31.5 13.2 31.5H22.8C25.3202 31.5 26.5804 31.5 27.543 31.0095C28.3897 30.5781 29.0781 29.8897 29.5095 29.043C30 28.0804 30 26.8202 30 24.3V22.2C30 19.6798 30 18.4196 29.5095 17.457C29.0781 16.6103 28.3897 15.9219 27.543 15.4905C27.0086 15.2182 26.3825 15.0971 25.5 15.0432M10.5 15.0432V12C10.5 7.85786 13.8579 4.5 18 4.5C22.1421 4.5 25.5 7.85786 25.5 12V15.0432",
    stroke: "#4ED5D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.cc49f909de87a41dfb45d915f9618a44.svg";
export { ForwardRef as ReactComponent };